const slider = document.querySelector('.slider-promu');
if (slider != null) {
    const nodes = document.querySelectorAll<HTMLElement>(
        '.umb-block-grid .bloc-promu'
    );
    slider.innerHTML = Array.from(nodes)
        .map(
            (node) =>
                `<a class="bloc-promu bloc-promu--slide tns-item tns-slide-active" href="${node.getAttribute('data-href')}">
                <div class="image">
                    <img src="${node.dataset.picture}" alt="${node.querySelector('.title')?.innerHTML ?? ''}">
                </div>
                <div class="content">
                    <div class="title">${node.querySelector('.title')?.innerHTML ?? ''}</div>
                    <div class="contenu">${node.querySelector('.contenu')?.innerHTML ?? ''}</div>
                </div>
            </a>`
        )
        .join('');
}

const grid = document.querySelector('.hp-grid');
if (grid) {
    const setupGrid = () => {
        if (window.innerWidth < 992) {
            grid.classList.add('hp-slider');
            grid.classList.remove('hp-grid');
        } else {
            grid.classList.remove('hp-slider');
            grid.classList.add('hp-grid');
        }
    };

    window.addEventListener('resize', setupGrid);
    setupGrid();
}
